export const sharedFields = {
  entityType: {
    presence: {
      message: 'Please select an entity type',
    },
  },
  industry: {
    presence: {
      message: 'Please select a valid industry',
    },
  },
  naicsCode: {
    presence: {
      message: 'Please select a valid industry',
    },
  },
}
